// import { useRouter } from 'vue-router'
import { computed, onMounted, reactive } from 'vue';
import Button from '@/components/ui/button/index.vue';
import Table from '@/components/ui/tablebox/index.vue';
import TableInfo from '@/components/ui/tableinfo/index.vue';
import Select from '@/components/ui/select/index.vue';
import CTmenu from '@/components/ui/ctmenu/index.vue';
import Pagination from '@/components/ui/pagination/index.vue';
import ActionBar from '@/components/ui/actionbar/index.vue';
import { ACTIONBAR, ATTR_NAME, FEATURENAME, FILTER_TYPE, FUNC_NAME, POPUP } from '@/enum/enum';
import { uuid } from 'vue-uuid';
import { apiTargetDel, apiTargetList, apiExportTargets, apiImportTarget } from '@/api/api';
import { dateTimeHandle } from '@/utils/time';
import { brightnessHandler, checkDisplayValue, colorGamutHandler, coordinateHandler, colorstandardHandler , dynamicRangeHandler, eotfHander, gamutCustomHandler, optionDynamicRange, temperatureHander } from '@/utils/attribute';
import { getGroupModelData } from '@/utils/utils';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';


export default {
  components: {
    Button,
    Select,
    Table,
    TableInfo,
    CTmenu,
    Pagination,
    ActionBar
  },
  props: {
    // tabText:{

    // }
  },
  setup() {

    const { t } = useI18n();
    const store = useStore();
    const route = useRouter();
    let pages = reactive({
      totalPage: 1,
      current: 1,
    });
    // select optoin
    let options = reactive({
      options: [],
      model: [],
      ranage: [],
      placeholder: {},
      selected: {},

    })

    let filter = reactive({
      model: '',
      range: -1,
      sort: '',
      page: -1,
    });

    const state = reactive({
      op1: [
        {
          text: t('__c3d_t4t.__allTargets'),
          val: 'all',
          isI18n: '__c3d_t4t.__allTargets',
        },
        {
          text: t('__common.__model'),
          val: 'modal',
          isI18n: '__common.__model',
          sub: [{

          }]
        },
        {
          text: t('__g3p_m8t.__dynamicRange'),
          val: 'range',
          isI18n: '__g3p_m8t.__dynamicRange',
          sub: [{
            text: 'SDR',
            val: 0
          },
          {
            text: 'HDR',
            val: 1
          }]
        }
      ],
      selectVal1: {
        text: '請選擇',
        val: 'default',
      },
      dataInfoCol: [
        {
          title: "Brightness",
          key: ATTR_NAME.BRIGHTNESS,
        },
        {
          title: "Color Temperature",
          key: ATTR_NAME.COLOR_TEMP
        },
        {
          title: "Gamma",
          key: ATTR_NAME.GAMMA,
        },
        {
          title: "EOTF",
          key: ATTR_NAME.EOTF,
        }
      ],
      dataList: [],
      iconList: [
        {
          name: 'asus_proart_sw_ico_control_settings',
          val: ACTIONBAR.SETCAL,
          disabled: false
        },
        {
          name: 'download',
          val: ACTIONBAR.VIEWHIS,
          disabled: false
        },
        {
          name: 'download',
          val: ACTIONBAR.VIEWAPP,
          disabled: false
        },
        {
          name: 'asus_proart_sw_ico_settings',
          val: ACTIONBAR.SETTING,
          disabled: false
        },
        {
          name: 'asus_proart_sw_ico_download',
          val: ACTIONBAR.DOWNLOAD,
          disabled: false
        },
      ],
      list: [],
      selectedId: [], //被選擇的id list
      order: 'desc',


    })

    // const route = useRouter()
    // const fatherLink = route.currentRoute.value.fullPath;

    onMounted(() => {
      getData();
      handleFilterOption(); // 
    });

    const column = computed(() => {
      return [  //title
        {
          title: t('__g3p_m8t.__dateCreated'),
          key: ATTR_NAME.CREATE_DATE,
          sort: true,

        },
        {
          title: t('__c3d_t4t.__targetName'),
          key: ATTR_NAME.TARGET_NAME,
          sort: true,

        },
        {
          title: t('__d7d_n17r.__modelName'),
          key: ATTR_NAME.MODEL_NAME,
          sort: true,
        },
        {
          title: t('__g3p_m8t.__dynamicRange'),
          key: ATTR_NAME.DYNAMIC_RANGE,
          sort: true,
        },
        {
          title: t('__c3d_t4t.__colorGamut'),
          key: ATTR_NAME.GAMUT,
          sort: true,
        },
      ]

    })





    const appListColSub = computed(() => {
      return {
        brightness: t('__d4e_m8t.__brightness'),
        colorTemperature: t('__d4e_m8t.__colorTemperature'),
        coordinate: t('__d4e_m8t.__coordinate'),
        standard: t('__c3d_t4t.__standardValue'),
        eotf: t('__d4e_m8t.__eotf'),
        gamutCustom: t('__c3d_t4t.__colorGamut'),
      }
    })

    const setAppListColSub = (e) => {
      let temp = [];
      
      // 1. Add brightness (if not the colorTempType)
      if (e.colorTempType !== 'brightness') {
        temp.push({
          'title': appListColSub.value['brightness'],
          'key': 'brightness'
        });
      }
      
      // 2. Add the color temperature type (colorTemperature, coordinate, or standard)
      if (e.colorTempType) {
        temp.push({
          'title': appListColSub.value[e.colorTempType],
          'key': e.colorTempType
        });
      }
      
      // 3. Add eotf (if not the colorTempType)
      if (e.colorTempType !== 'eotf') {
        temp.push({
          'title': appListColSub.value['eotf'],
          'key': 'eotf'
        });
      }
      
      // 4. Add gamutCustom if it exists in the data
      if (e.gamutCustom || e['gamutCustom']) {
        temp.push({
          'title': appListColSub.value['gamutCustom'],
          'key': 'gamutCustom'
        });
      }
      
      console.log(temp)
      return temp
    }




    const getData = async (model = '', range = -1, sort = 'created_at', page = -1, order = state.order) => {
      console.log('getData - model, range, sort, page:', model, range, sort, page, order);
      console.log('page', page);
      let data = null;
      try {
        data = await apiTargetList(model, range, sort, page, order);
        console.log('handleData', data, data.data);
        handleData(data);
        console.log('handlePage', data);
        handlePage(data);

      }
      catch (err) {
        console.warn('apiTargetList Error', err.response);
      }
    }


    const handleData = (datas) => {
      state.dataList = [];
      const _datas = datas.data;
      const data = [..._datas];
      console.log('handleData', data);
      // table data handle
      data.forEach(item => {
        // level2 handlee

        let colorTemperature;
        let colorTempType = '';

        if(item.color_temperature){
          colorTemperature = temperatureHander(item.color_temperature);
          colorTempType = 'colorTemperature';
        } else if (item.color_x && item.color_y) {
          colorTemperature = coordinateHandler(item.color_x, item.color_y);
          colorTempType = 'coordinate';
        } else {
          colorTemperature = colorstandardHandler(item.color_standard); // Assuming standard_value exists
          colorTempType = 'standard';
        }

        let brightness = brightnessHandler(item.brightness, item.brightness_min, item.eotf);
        // let colorTemperature = temperatureHander(item.color_temperature);
        let eotf = eotfHander(item.eotf, item.gamma);
        let gamma = checkDisplayValue(item.gamma, item.eotf);

        // Build dataInfo object
        let dataInfoObj: any = {
          colorTempType: colorTempType,
          id: item.id,
          [ATTR_NAME.BRIGHTNESS]: brightness,
          [colorTempType === 'colorTemperature' ? ATTR_NAME.COLOR_TEMP : (colorTempType === 'coordinate' ? ATTR_NAME.COORD : ATTR_NAME.STANDARD_VALUE)]: colorTemperature,
          [ATTR_NAME.GAMMA]: gamma,
          [ATTR_NAME.EOTF]: eotf
        };

        // Add gamut_custom if gamut is 7 (Custom)
        if (item.gamut === 7 && item.gamut_custom) {
          dataInfoObj['gamutCustom'] = gamutCustomHandler(item.gamut_custom);
        }

        // level1 data handle
        state.dataList.push({
          [ATTR_NAME.CREATE_DATE]: dateTimeHandle(item.created_at),
          [ATTR_NAME.TARGET_NAME]: item.name,
          [ATTR_NAME.MODEL_NAME]: item.model,
          [ATTR_NAME.DYNAMIC_RANGE]: dynamicRangeHandler(item.color_range),
          [ATTR_NAME.GAMUT]: colorGamutHandler(item.gamut),
          dataInfo: [dataInfoObj],

        }) // end: dataList push
      }); //end: data forEach
      // for (let i = 0; i < data.length; i++) {
      //   data[i] = Object.fromEntries(Object.entries(data[i]).filter(([key]) => { return key != 'gamma' }));
      // }

      console.log('end data forach',data);


    } //end: handlData

    // pager 
    const handlePage = (data) => {
      console.log('data.current_page;', data.current_page);
      pages.current = data.current_page;
      pages.totalPage = data.last_page;
    }
    const changePage = (page) => {
      console.log('chamgePage', page);
      pages.current = page;
      filter.page = pages.current;
      getData(filter.model, filter.range, filter.sort, filter.page);
    }

    // watch(
    //   () => pages.current,
    //   (val) => {
    //     console.log('current page', val);
    //     // filter.page = val;
    //     // console.log('filter.page', filter.page);
    //     // getData(filter.model, filter.range, filter.sort, filter.page);
    //   }
    // );

    // sort table
    const tableSort = (v) => {
      const { key, val } = v;
      state.order = v.val === 'up' ? 'asc' : 'desc';
      console.log(v, 'sort table', key, val);
      let sort = '';
      switch (key) {
        case ATTR_NAME.CREATE_DATE:
          sort = 'created_at';
          break;
        case ATTR_NAME.TARGET_NAME:
          sort = 'name';
          break;
        case ATTR_NAME.MODEL_NAME:
          sort = 'model';
          break;
        case ATTR_NAME.DYNAMIC_RANGE:
          sort = 'color_range';
          break;
        case ATTR_NAME.GAMUT:
          sort = 'gamut';
          break;
      }//end: switch
      filter.sort = sort;
      getData(filter.model, filter.range, filter.sort, filter.page);
    }

    // option 處理
    const handleFilterOption = async () => {
      options.options = [];
      options.placeholder = {
        text: t('__c3d_t4t.__allTargets'),
        val: 'all',
        isI18n: '__c3d_t4t.__allTargets',
      };
      options.options.push(options.placeholder);
      options.selected = { ...options.placeholder };
      console.log('options', options.selected);

      const model = await getGroupModelData(FILTER_TYPE.MODEL);
      console.log('cloud target getGroupModelData', model); //todo check model no data in staging
      if (model) {
        let subModel = [];
        model.forEach(item => {
          subModel.push({
            text: item,
            val: `${FILTER_TYPE.MODEL}_${item}`,
          })
        })//end: forEach
        options.options.push({
          text: t('__common.__model'),
          val: 'modal',
          isI18n: '__common.__model',
          sub: subModel
        });
      }//end: model

      // range (need remove 2)
      const range = optionDynamicRange.filter(item => item.val != 2);
      options.options.push({
        text: t('__g3p_m8t.__dynamicRange'),
        val: 'range',
        isI18n: '__g3p_m8t.__dynamicRange',
        sub: range,
      })


    } //end: handleFilterOption

    // filter table
    const onChangeFilter = (selected) => {
      console.log('selected', selected);
      const { val } = selected;
      filter.page = -1; //要跳回第一頁
      if (val === FILTER_TYPE.ALL) {
        filter.model = '';
        filter.range = -1;
        filter.sort = '';
        getData(filter.model, filter.range, filter.sort, filter.page);
      }
      else if (typeof val === 'number') {
        // ranage
        filter.model = '';
        filter.range = val;
        filter.sort = '';
        getData(filter.model, filter.range, filter.sort, filter.page);
      } else {
        // model
        let model = val.split('_')[1];
        filter.model = model;
        filter.range = -1;
        filter.sort = '';
        getData(filter.model, filter.range, filter.sort, filter.page);
      }//end: else
    } //end: onChangeFilter


    // check to delete
    const onCheckAll = (v) => {
      state.list = v;
      console.log('onCheckAll', v);
      state.selectedId = [];
      state.selectedId = v.map(item => item.dataInfo[0].id);
    }

    const onCheckEach = (v) => {
      console.log('onCheckEach', v);
      state.list = v
      state.selectedId = [];
      state.selectedId = v.map(item => item.dataInfo[0].id);
    }

    // click button applyCalibration
    const applyCalibration = (v) => {
      var _data;
      var _id = v[0].id
      // console.log(state.dataList, 'applyCalibration')
      for (var a = 0; a < state.dataList.length; a++) {
        if (state.dataList[a].dataInfo[0].id == _id) {
          _data = state.dataList[a]
        }
      }
      store.commit('setCalibrationList', { content: _data, title: FUNC_NAME.TARGET })
      route.push({ name: FEATURENAME.CALIBRATION });


    }


    const goTableLink = (v) => {
      console.log(v, 'table link')
    }

    // table handle
    const showCTAndRow = (v) => {
      state.list = v.list
    }

    // delete 
    const btnDelete = reactive({
    });


    const isBtnDelDiable = computed(() => state.list.length === 0)

    const delTarget = async () => {
      console.log('delTarget');

      console.log('delIdList', state.selectedId);

      const _data = {
        id: state.selectedId,
        appointment: true,
      }
      try {
        await apiTargetDel(_data);
        state.selectedId = [];
        getData();
      }
      catch (err) {
        console.warn('error in apiTargetDel');

      }//end: catch


    }; //delTarget


    const importTarget = () => {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.json';
      input.onchange = async (e) => {
        const file = (e.target as HTMLInputElement).files[0];
        if (!file) {
          return;
        }
        const formData = new FormData();
        formData.append('file', file);

        try {
          const response = await apiImportTarget(formData);
          if (response.status_code === 0) {
            getData(); // Refresh data on success
          } else {
            // Show popup with error message
            const modalConfig = {
              type: POPUP.APIERROR + uuid.v4(),
              data: response.message,
              isShow: true,
            };
            store.commit('setIsShowModal', modalConfig);
          }
        } catch (err) {
          console.error('Error during import:', err);
          const modalConfig = {
            type: POPUP.APIERROR + uuid.v4(),
            data: 'An unknown error occurred during import.',
            isShow: true,
          };
          store.commit('setIsShowModal', modalConfig);
        }
      };
      input.click();
    };

    const exportTarget = async () => {
      console.log('Export button clicked. Preparing to export...');
      if (state.selectedId.length === 0) {
        console.log('No items selected. Aborting export.');
        return;
      }
      const _data = {
        id: state.selectedId,
      };
      console.log('Exporting with the following data:', _data);
      try {
        const response = await apiExportTargets(_data);
        console.log('API response received:', response);

        // Generate filename with current datetime: target_YYYY-MM-DD_HHmmss.json
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const filename = `target_${year}-${month}-${day}_${hours}${minutes}${seconds}.json`;

        const url = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        console.log('File download triggered.');
      }
      catch (err) {
        console.error('Error during export:', err);
      }
    };


    return {
      state,
      tableSort,
      onCheckAll,
      onCheckEach,
      goTableLink,
      showCTAndRow,
      changePage,
      applyCalibration,
      onChangeFilter,
      pages,
      options,
      btnDelete,
      isBtnDelDiable,
      delTarget,
      t,
      column,
      setAppListColSub,
      appListColSub,
      importTarget,
      exportTarget,
    }
  }// end: setup

}



